export function NodeIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor">
      <path d="M7,9L5,9L5,7L7,7L7,5L9,5L9,7L12,7L12,5L15,8L12,11L12,9L9,9L9,12L11,12L8,15L5,12L7,12L7,9Z" />
    </svg>
  );
}
